import React from 'react';
import QLoginRedirect from '_Components/Auth/QLoginRedirect';
import Layout from '_Layouts/Layout';
import SyntheticViewGeneric from '../../_Containers/SyntheticViewGeneric/SyntheticViewGeneric';

const title = 'Synthetic view - Comm';
const body = (
  <SyntheticViewGeneric idpage="comm-synthetic-view" thematic="comm" />
);

const action = props => (
  <QLoginRedirect>
    <Layout body={body} title={title} {...props} />
  </QLoginRedirect>
);

export default action;
